import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const TrophyIcon = (props) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={53}
      height={52}
      viewBox="0 0 53 52"
      fill="none"
      {...props}
    >
      <path
        d="M15.667 45.5v-4.333h8.666V34.45a11.6 11.6 0 0 1-4.738-2.247 9.7 9.7 0 0 1-3.062-4.145q-4.062-.488-6.797-3.546Q7.002 21.452 7 17.333v-2.166q0-1.788 1.274-3.06t3.06-1.274h4.333V6.5h21.666v4.333h4.334q1.787 0 3.061 1.274T46 15.167v2.166q0 4.118-2.736 7.179t-6.797 3.546a9.7 9.7 0 0 1-3.06 4.145 11.6 11.6 0 0 1-4.74 2.247v6.717h8.666V45.5zm0-22.1v-8.233h-4.334v2.166q0 2.06 1.192 3.712a6.5 6.5 0 0 0 3.142 2.355m21.666 0a6.5 6.5 0 0 0 3.142-2.357 6.2 6.2 0 0 0 1.192-3.71v-2.166h-4.334z"
        fill="#F59E0C"
      />
    </svg>
  </SVGUniqueID>
);
export { TrophyIcon };
